import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import TablaDetalle from './DetalleConsumoProducto';
import TablaDetalleVer from './DetalleConsumoProductoVer';
import styled from 'styled-components';

import {
    AsyncSelectField,
    renderField,
    renderDayPickerB,
    AsyncSelectFieldIn,
    renderCurrencyFloatTC
} from "../../Utils/renderField/renderField";

function ConsumoProductoForm(props) {
    const {
        periodoD,
        modulo,
        datos,
        titulo,
        crear,
        editar,
        bloqueo,
        agregarLinea,
        registroOrden,
        detalleOrden,
        detalleOrd,
        eliminarLineaProductoNuevo,
        leerProductos,
        listarBodegas,
        pro,
        listarProyectos,
        buscarPresupuesto,
        presupuestos
    } = props;

    let autoFocus = true;
    const estilo = {
        overflow: "auto",
        height: "500px",

    };
    
    const handleOnChange = value => {
        leerProductos(value.value, datos, periodoD);
    };

    const handleOnChangeProyecto = value => {
        buscarPresupuesto(value.value);
    };

    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <NavbarModulo
                periodoD={periodoD}
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='row mb-2'>
                            <div className='col-2'>
                                <Field
                                    autoFocus={autoFocus}
                                    disabled={bloqueo}
                                    name="fecha"
                                    component={renderDayPickerB}
                                    msj="Fecha"
                                />
                            </div>
                            {crear === true &&
                                <div className='col-5'>
                                    <Field
                                        name="proyecto"
                                        placeholder="Orden de servicio..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        onChange={handleOnChangeProyecto}
                                        loadOptions={listarProyectos}
                                        msj="Orden de servicio / proyecto"
                                    />
                                </div>
                            }
                            {crear === true &&
                                <div className='col-5'>
                                    <Field
                                        name="presupuesto"
                                        placeholder="Presupuesto..."
                                        className="form-control-find"
                                        loadOptions={presupuestos}
                                        component={AsyncSelectFieldIn}
                                        msj="Presupuesto"
                                    />
                                </div>
                            }
                            {crear === false && editar === false &&
                                <div className='col-2'>
                                    <Field
                                        name="numero"
                                        placeholder="Numero"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Numero"
                                    />
                                </div>
                            }
                        </div>
                        {crear === false && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <Field
                                        name="proyectoN"
                                        placeholder="Orden de servicio / proyecto"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Orden de servicio / proyecto"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <Field
                                        name="presupuesto"
                                        placeholder="Presupuesto"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Presuspuesto"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <Field
                                        name="clienteN"
                                        placeholder="Cliente"
                                        className="form-control"
                                        component={renderField}
                                        disabled={bloqueo}
                                        msj="Cliente"
                                    />
                                </div>
                            </div>
                        }
                        <div className='mb-2'>
                            <Field
                                name="observaciones"
                                placeholder="Observaciones"
                                component={renderField}
                                className="form-control"
                                disabled={bloqueo}
                                msj="Observaciones"
                            />
                        </div>
                        <h5 className="p-2 bg-secondary title mt-1">Detalle de productos</h5>
                        {crear === true &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-3'>
                                        <Field
                                            name="bodega"
                                            placeholder="Bodega..."
                                            className="form-control-find"
                                            loadOptions={listarBodegas}
                                            component={AsyncSelectField}
                                            onChange={handleOnChange}
                                            msj="Bodega"
                                        />
                                    </div>
                                    <div className='col-7'>
                                        <Field
                                            name="producto"
                                            placeholder="Producto..."
                                            className="form-control-find"
                                            loadOptions={pro}
                                            component={AsyncSelectFieldIn}
                                            msj="Producto"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="cantidad"
                                            placeholder="Cantidad"
                                            className="form-control"
                                            component={renderCurrencyFloatTC}
                                            disabled={bloqueo}
                                            msj="Cantidad"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {(crear === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => {
                                        agregarLinea(periodoD, datos);
                                    }}
                                >
                                    Agregar
                                </button>
                            </Contenido>
                        }
                        {(editar === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => {
                                        agregarLinea(periodoD, datos);
                                    }}
                                >
                                    Agregar
                                </button>
                            </Contenido>
                        }
                        {crear === true &&
                            <div style={estilo}>
                                <TablaDetalle
                                    detalle={detalleOrden}
                                    eliminarLineaProducto={eliminarLineaProductoNuevo}
                                />
                            </div>
                        }
                        {crear === false &&
                            <div style={estilo}>
                                <TablaDetalleVer
                                    detalle={detalleOrd}
                                />
                            </div>
                        }

                        <br />
                        <div className='d-flex flex-row mt-3'>
                            {crear === true &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => registroOrden(periodoD, detalleOrden)}
                                >
                                    Guardar
                                </button>
                            }
                            <a
                                href={`/#/inventario/${id_emp[5]}/consumo_producto/${id_emp[7]}`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ConsumoProductoForm.propTypes = {
    crear: PropTypes.bool,
};

export default reduxForm({
    form: 'FormConsumoProductoINV',
})(ConsumoProductoForm);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;